const BUILD_HASH_THROTTLE_MS = 5 * 60 * 1000 // 5 minutos entre checks

export default {
    methods: {
        async checkBuildHash() {
            if (process.env.NODE_ENV !== 'production') return

            // Throttle: no chequear si ya se chequeó hace menos de 5 minutos.
            // localStorage puede estar bloqueado (modo privado / webview in-app),
            // en ese caso salimos silenciosamente sin romper el arranque de la app.
            let lastChecked = 0
            try {
                lastChecked = Number(localStorage.getItem('buildHashLastChecked') || 0)
            } catch (e) {
                return
            }
            if (Date.now() - lastChecked < BUILD_HASH_THROTTLE_MS) return

            try {
                // fetch nativo (más liviano que axios para un JSON simple)
                // cache: 'no-cache' respeta los headers del servidor sin cache-busting en URL
                const response = await fetch('/build-hash.json', { cache: 'no-cache' })
                if (!response.ok) return

                const data = await response.json()
                const currentHash = data.buildHash
                if (!currentHash) return

                localStorage.setItem('buildHashLastChecked', String(Date.now()))

                const cachedHash = localStorage.getItem('buildHash')
                if (cachedHash && cachedHash !== currentHash) {
                    localStorage.setItem('buildHash', currentHash)
                    setTimeout(() => { window.location.reload() }, 1000)
                } else if (!cachedHash) {
                    localStorage.setItem('buildHash', currentHash)
                }
            } catch {
                // Silencioso — no bloquear la app si falla
            }
        }
    },
    mounted() {
        this.checkBuildHash()
    },
    watch: {
        '$route.path': 'checkBuildHash'
    }
}